import { useState } from "react";
import { Copy, Check } from "lucide-react";
import { toast } from "sonner";

export function CopyButton({ value, testid, label = false }) {
  const [copied, setCopied] = useState(false);

  const copy = async (e) => {
    e.stopPropagation();
    try {
      await navigator.clipboard.writeText(value);
      setCopied(true);
      toast.success("UPI ID copied");
      setTimeout(() => setCopied(false), 1500);
    } catch {
      toast.error("Copy failed — long-press to copy manually");
    }
  };

  return (
    <button type="button" onClick={copy} data-testid={testid} title="Copy UPI ID"
      className="inline-flex items-center gap-1 px-1.5 py-1 rounded-lg text-slate-400 hover:text-blue-700 hover:bg-blue-50 transition-colors align-middle">
      {copied ? <Check className="w-3.5 h-3.5 text-green-600" /> : <Copy className="w-3.5 h-3.5" />}
      {label && <span className={`text-xs font-semibold ${copied ? "text-green-600" : ""}`}>{copied ? "Copied!" : "Copy"}</span>}
    </button>
  );
}
